import { ComponentProps, forwardRef } from 'react';

import clsx from 'clsx';

import SearchIcon from '~/icons/search.svg';
import { InputField } from '~/shared/components/FormElements/components/InputField/InputField';
import { useTranslation } from '~/shared/utils/translation/hooks/useTranslation';

import styles from './searchInputField.module.css';

export const SearchInputField = forwardRef<HTMLInputElement, ComponentProps<typeof InputField>>(({ onSubmit, className, ...props }, ref) => {
	const { translate } = useTranslation();
	return (
		<InputField
			ref={ref}
			placeholder={translate('search.menu-label')}
			hideLabel
			prepend={<SearchIcon onClick={onSubmit} />}
			className={clsx(styles.root, className)}
			{...props}
		/>
	);
});
